module.exports={
	"Scope": "Contract-List",
	"CoreEntity": "Contract",
	"TitleTemplate": "Contracts",
	"Descriptors":
	{
		"Name":
		{
			"Name": "Name",
			"Hash": "ContractListName",
			"PictDashboard": {}
		},
		"PrimaryProjectNumber":
		{
			"Name": "Primary Project #",
			"Hash": "ContractListPrimary",
			"PictDashboard": {}
		},
		"Status":
		{
			"Name": "Status",
			"Hash": "ContractListStatus",
			"PictDashboard":
			{
				"ValueTemplate": "<span class=\"tag has-text-weight-bold {~TIfAbs:PSRS-StatusTag-Success:Record:Record.Payload.Status^==^Construction~}{~TIfAbs:PSRS-StatusTag-Info:Record:Record.Payload.Status^==^Pending~}{~TIfAbs:PSRS-StatusTag-Danger:Record:Record.Payload.Status^==^Closed~}\">{~D:Record.Payload.Status~}</span>"
			}
		}
	}
}
